import React from 'react'

const TimeToSellTable = ({data}) => {
  return (
    <>
        <div className='custom-table time-sell-table'>
            <table border="1" style={{ width: '100%', borderCollapse: 'collapse' }}>
                <thead>
                    <tr>
                        <th className='text-start'>
                            &nbsp;
                        </th>
                        <th className='text-uppercase'>Total Vehicles</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td><span className='ts-circle d-inline-block ts-green-circle'></span> Vehicles 0 - 30 Days</td>
                        <td>{data['0_days']}</td>
                    </tr>
                    <tr>
                        <td><span className='ts-circle d-inline-block ts-yellow-circle'></span> Vehicles 30 - 60 Days</td>
                        <td>{data['30_days']}</td>
                    </tr>
                    <tr>
                        <td><span className='ts-circle d-inline-block ts-red-circle'></span> Vehicles 60+ Days</td>
                        <td>{data['60_days']}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </>
  )
}

export default TimeToSellTable